import React, { useEffect, useState } from 'react';
import { LayoutContext } from 'components/app-routes';
import { addAgentCode, redirectToHome, redirectToOld, } from '__utils/common-utils';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import { useMediaQuery } from 'react-responsive';
import { COLOR } from 'constants/colors';
import { ENDPOINTS } from 'constants/endpoints';
import { get } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import NfosCard from './nfoCard';
import filterIcon from '../../images/filterIcon.svg';
import sortIcon from '../../images/sortIcon.svg';
import FilterPopup from './filterPopup';
import SortPopup from './sortPopup';
import openNfo from '../../images/openNfo.svg';
import upComingNfo from '../../images/upComingNfo.svg';
import closedNfo from '../../images/closedNfo.svg';
import closedListedNfo from '../../images/closedListedNfo.svg';
import farthestFirst from  '../../images/farthestFirst.svg';
import earliestfirst from  '../../images/earliestfirst.svg';

const OuterContainer = styled.div<CommonStyledComponentProps>`
    position: relative;
    .nfo-heading{
        padding: ${(props) => props.isMobile ? '16px' : '24px 0 15px'};
        background: white;
        border-bottom: 0.5px solid  #D2D5D6;
        margin-bottom: ${(props) => props.isMobile ? '16px' : '40px'};
        h4{
            font-weight: 500;
            font-size: ${(props) => props.isMobile ? '16px' : '26px'};
            line-height: 19px;
            margin: 5px 0 10px;
            padding: ${(props) => props.isMobile ? '' : '0 20px'};
        }
        p{
            font-style: normal;
            font-weight: 400;
            font-size: ${(props) => props.isMobile ? '12px' : '16px'};
            line-height: ${(props) => props.isMobile ? '16px' : '22px'};
            color: ${COLOR.GREY3};
            width: ${(props) => props.isMobile ? '' : '591px'};
            padding: ${(props) => props.isMobile ? '' : '0 20px'};
        }
        .filterSort {
            padding: ${(props) => props.isMobile ? '' : '0 16px'};
            display: flex;
            justify-content: space-between;
            align-content: center;
            margin: 20px auto 0;
            border-top: ${(props) => props.isMobile ? '' : '0.5px solid  #D2D5D6'};
            padding-top: ${(props) => props.isMobile ? '' : '14px'};
            
            p{
                color: var(--green);
                font-size: ${(props) => props.isMobile ? '14px' : ''};
            }
            .filter, .sort {
                display: flex;
                justify-content: center;
                cursor: pointer;
                img{
                    margin-right: 5px;
                }
                p{
                    padding: ${(props) => props.isMobile ? '' : '0!important'}
                }
            }
            .sort{
                width: ${(props) => props.isMobile ? '' : '82px'};
                &.filterNameWidth{
                    width: 180px;
                }
                img{
                    width:20px;
                }
            }
        }
    }
    .nfoNotAvailable{
        background: white;
        font-size: ${(props) => props.isMobile ? '16px' : '18px'};
        text-align: center;
        padding: 24px;
        font-weight: 500;
    }
    
`;
const NfoTitle = styled.div<CommonStyledComponentProps>`
    font-weight: 500;
    font-size: ${(props) => props.isMobile ? '16px' : '20px'};
    line-height: 19px;
    padding: ${(props) => props.isMobile ? '16px 16px 13px' : '30px 30px 23px'};
    background: white;
    position: relative;
    background-color: #D3E1FF;
    border-radius: 4px 4px 0px 0px;

    .nfoTitleImg{
        position: absolute;
        top: ${(props) => props.isMobile ? '-5px' : '-10px'};
        right: ${(props) => props.isMobile ? '6px' : '30px'};
        height: ${(props) => props.isMobile ? '57px' : '90px'};
    }
`;

const NFOsPage: React.FC = () => {
    const { SetLayoutProps } = React.useContext(LayoutContext);
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [nfosList, setNfosList] = useState<Array<any>>([]);
    const [filteredNfosList, setFilteredNfosList] = useState<Array<any>>([]);
    const [openFilter, setOpenFilter] = useState(false);
    const [openSort, setOpenSort] = useState(false);
    const [filterCount, setFilterCount] = useState<any>();
    const [filterSelected, setFilterSelected] = useState<any>();
    const [sortSelected, setSortSelected] = useState<any>();

    const nfoTitlesList: any = {
        1: 'Open NFO’s',
        2: 'Upcoming NFO’s',
        3: 'Recently Closed NFO’s',
        4: 'Closed & Listed NFO’s'
    }

    const nfoTitleIcon: any = {
        1: openNfo,
        2: upComingNfo,
        3: closedNfo,
        4: closedListedNfo,
    }

    const nfoTitleColor: any = {
        1: COLOR.openNfo,
        2: COLOR.upComingNfo,
        3: COLOR.closedNfo,
        4: COLOR.closedListedNfo,
    }
    const sortNFObyDate: any = {
        "launchEF": (nfo1: any, nfo2: any) => nfo1.nfoOpenDate - nfo2.nfoOpenDate,
        "launchFF": (nfo1: any, nfo2: any) => nfo2.nfoOpenDate - nfo1.nfoOpenDate,
        "closeEF": (nfo1: any, nfo2: any) => nfo1.nfoClousureDate - nfo2.nfoClousureDate,
        "closeFF": (nfo1: any, nfo2: any) => nfo2.nfoClousureDate - nfo1.nfoClousureDate
    }

    useEffect(() => {
        SetLayoutProps({
            config: {
                goBackCallback: () => redirectToHome(),
                title: `NFO`,
            },
            showBseInfoForDesktop: false,
            showCopyrightInfoForDesktop: true,
            breadcrumbList: [{ text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: 'New Fund Offerings', url: '/nfos', isExternal: false }]
        });
        getAllNfosOrders();
        Mixpanel.track(getEventName("nfoList", "loaded", "nfos"));
    }, []);

    //purpose: gets all NFOs sList
    const getAllNfosOrders = () => {
        get(ENDPOINTS.GET_NFO_FUNDS, {}, true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.data) {
                    setNfosList(response?.response?.data);
                    setFilteredNfosList(response?.response?.data);
                }

            }, (error: AjaxError) => {
                console.log(error);
            });
    }

    const getFilterValue = (filteredItems: Array<any>) => {
        let filteredListArr: any = [];
        let count = 0;
        if (filteredItems.some((obj: any) => Object.keys(obj).includes("isChecked") && obj?.isChecked)) {
            filteredItems.map((element: any, index: number) => {
                if (element?.isChecked) {
                    count++;
                    if (element.id === 0) filteredListArr.push(nfosList)
                    else filteredListArr.push([element.id].concat(nfosList[element.id]))
                }
            })
            setFilterCount(count);       
        }
        else {
            filteredItems.map((element: any, index: number) => {
                filteredListArr.push([element.id].concat(nfosList[element.id]))
                setFilterCount(null);       
            })
        }

        let filteredObj: any = {};
        filteredListArr?.forEach((nfoItem: any) => {
            let key = nfoItem[0];
            var value = nfoItem.slice(1, nfoItem.length);
            filteredObj[key] = value;
        });

        setFilteredNfosList(filteredObj);             
    }

    const getSortDate = (applyDate: any) => {
        if(applyDate === false){
            applyDate = 'launchEF';
            for (const key1 in filteredNfosList) {
                filteredNfosList[key1] = filteredNfosList[key1].sort(sortNFObyDate[applyDate]);
                setSortSelected('Sort By');
            }
        } else{
            for (const key in filteredNfosList) {
                filteredNfosList[key] = filteredNfosList[key].sort(sortNFObyDate[applyDate]);
                setSortSelected(applyDate);
            }
        }
    }

    return <OuterContainer isMobile={isMobile}>
        <div className='nfo-heading'>
            <h4>New Fund Offerings</h4>
            <p>A New Fund Offer (NFO) is how an asset management company launches a new fund on a first-subscription basis for financing its purchase of securities.</p>

            <div className='filterSort'>
                <div className="filter" onClick={() => setOpenFilter(true)}>
                    <div className='countFilter'>
                        <img src={filterIcon} alt="mf-nfo-filter" />
                        {filterCount ? <span>{filterCount}</span> : null}
                    </div>
                    <p>Filter By</p>
                </div>

                <div className={sortSelected && sortSelected !== 'Sort By' ? "sort filterNameWidth" : "sort"} onClick={() => setOpenSort(true)}>
                    { sortSelected ? 
                      <img src={(sortSelected === 'closeFF' || sortSelected === 'launchFF') && (sortSelected !== 'Sort By') 
                      ? farthestFirst : ((sortSelected === 'Sort By') 
                      ? sortIcon : earliestfirst) } alt="mf-nfo-filter" /> 
                      : <img src={sortIcon} alt="mf-nfo-filter" /> 
                    }
                    <p className={sortSelected ? 'hide' : 'show'}>Sort By</p>
                    <p className={sortSelected === 'launchEF' ? 'show' : 'hide'}>Earliest Launch First</p>
                    <p className={sortSelected === 'launchFF' ? 'show' : 'hide'}>Farthest Launch First</p>
                    <p className={sortSelected === 'closeEF' ? 'show' : 'hide'}>Earliest Close First</p>
                    <p className={sortSelected === 'closeFF' ? 'show' : 'hide'}>Farthest Close First</p>
                    <p className={sortSelected === 'Sort By' ? 'show' : 'hide'}>Sort By</p>
                </div>
            </div>
        </div>

        {/* nfo card box here */}
        <div className='nfoCardList'>
            {Object.entries(filteredNfosList).map((element: any, index: number) => (
                <div key={index}>
                    <NfoTitle isMobile={isMobile} key={element[0]} style={{ background: nfoTitleColor[element[0]] }}>
                        {nfoTitlesList[element[0]]}
                        <img src={nfoTitleIcon[element[0]]} className="nfoTitleImg" alt="nfoTitleImg"/>
                    </NfoTitle>
                    <p className={(element[1].length) ? 'hide' : 'show nfoNotAvailable'}>Not yet available</p>
                    <NfosCard nfoCardItem={element[1]} key={element[1]} />
                </div>
            ))}
        </div>

        {/* filter sort popup here */}
        {openFilter ? <FilterPopup onClose={setOpenFilter} getFilterValue={getFilterValue} isCheckedFilter={filterSelected} /> : null}
        {openSort ? <SortPopup onClose={setOpenSort} getSortDate={getSortDate} /> : null}

    </OuterContainer>;
}

export default NFOsPage;